import { space } from "venuescanner-js/schemas/serviceSchema.json";
import { urls } from "venuescanner-js/services/endPoints";
/** @class
 * @name Space
 * @desc Class definition of a Space - schema defined in venuescanner-js/schemas/serviceSchema.json
 * @param {Object} [values={}] - The values to apply to the model
 */
class Space {
  constructor(values = {}) {
    Object.keys(space).forEach((key) => {
      this[key] = values[key];
    });
  }

  /** @function
   * @memberof Space
   * @name photoURL
   * @param {string} size - Defaults to min
   * @desc Returns the first photo URL or the Venue first photo URL
   * @returns {string}
   */
  photoURL(size = "min") {
    if (this._venue) {
      if (this.photos.length) {
        return `${urls.PHOTOS_URL}/${this._venue.hashcode}/${size}_${this.photos[0].filename}`;
      } else {
        return this._venue.photoURL();
      }
    }
    return null;
  }

  /** @function
   * @memberof Space
   * @name sdp
   * @desc Returns the URL of the SDP
   * @returns {string}
   */
  sdp() {
    return `${urls.RAILS_URL}${this.url}`;
  }
}

export default Space;
